export default "__VITE_ASSET__SQ9N2vPA__"